import type { Tax } from './tax.model';

export interface GenerateTaxOptions {
  readonly authUserId: number;
  readonly rate?: number;
  readonly eligible?: boolean;
  readonly name?: string;
}

// TODO: T267853 - Generate tax objects for different countries
export function generateTaxObject({
  authUserId,
  rate = 0.1,
  eligible = false,
  name = '',
}: GenerateTaxOptions): Tax {
  return {
    id: authUserId.toString(),
    name,
    rate,
    eligible,
  };
}
